{
  "requests.view.board": "Board by status",
  "requests.view.cards": "Cards",
  "requests.description": "What each buyer is looking for, written as a brief your team can match to units.",
  "requests.search": "Search buyer or brief…",
  "requests.buyer": "Buyer",
  "requests.status.new": "New",
  "requests.status.pending": "Pending",
  "requests.status.open": "Open",
  "requests.status.closed": "Closed",
  "requests.visibility.public": "Visible to the whole team",
  "requests.visibility.private": "Visible to the owner and their leaders",
  "requests.visibility.makePublic": "Share with the whole team",
  "requests.visibility.makePrivate": "Make private",
  "requests.matches": "{count, plural, one {# matching unit} other {# matching units}}",
  "requests.editBrief": "Edit brief",
  "requests.reassign": "Reassign",
  "requests.reassigned": "Request reassigned.",
  "requests.created": "Request added.",
  "requests.newBody": "Pick the buyer's deal, then describe what they want: budget, area, type, size and timing.",
  "requests.deal": "Buyer deal",
  "requests.pickDeal": "Choose a buyer",
  "requests.noBuyers": "No buyer deals yet. Mark a lead as “Interested to buy” to open one.",
  "requests.brief": "Brief",
  "requests.briefPlaceholder": "e.g. 3-bedroom apartment in New Cairo, up to EGP 9M, semi-finished, delivery within 2 years.",
  "requests.helper.budget": "Budget",
  "requests.helper.area": "Area",
  "requests.helper.type": "Type",
  "requests.helper.beds": "Bedrooms",
  "requests.helper.delivery": "Delivery",
  "requests.empty.title": "No requests yet",
  "requests.empty.body": "Open a buyer deal in Pipeline, then add what they're looking for.",
  "requests.empty.filtered": "No requests here",
  "requests.delete.title": "Delete {name}'s request?",
  "requests.delete.body": "The brief goes; the buyer's deal stays.",
  "requests.delete.done": "Request deleted."
}
